import AnnotationModel from 'models/AnnotationModel';

export default class AnnotationCollection extends Backbone.Collection {

    get model() {
        return AnnotationModel
    }

    preinitialize() {
        this.constructor.type = 'annotations'
    }

    loadAnnotations(id, type) {
        switch (type) {
            case 'schoolSchoolclassCourse':
                this.url = '/annotations/load_annotations_for_course/' + id + '.json';
                break;
        }
    }

    // Make a save annotation function for inheritence
    createAnnotation(data, callback) {
        if (data.note_content.trim().length > 1) {
            // Save the new annotation
            this.create(
                data,
                {
                    success: callback,
                }
            )
        }
    }

}
